"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _reactPlacesAutocomplete = _interopRequireWildcard(require("react-places-autocomplete"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _palette = require("../../../../styles/palette");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _styles = require("../styles");

var _icons = require("../../../../static/icons/icons");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var messages = {
  addressNotValidated: {
    en: 'We need a complete address (including number)',
    es: 'Necesitamos la dirección completa (con número)'
  },
  addressNotInCoverage: {
    en: 'Sorry, but the address is outside of our coverage area',
    es: 'Lo sentimos, pero todavía no operamos en su zona'
  }
};

var Address = function (_React$Component) {
  (0, _inherits2["default"])(Address, _React$Component);

  var _super = _createSuper(Address);

  function Address(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Address);
    _this = _super.call(this, props);

    _this.onChange = function (address) {
      var handleChange = _this.props.handleChange;
      if (handleChange) handleChange();

      _this.setState({
        address: address,
        addressObject: null,
        dirty: address !== ''
      });
    };

    _this.onFocus = function () {
      var handleFocus = _this.props.handleFocus;
      if (handleFocus) handleFocus();

      _this.setState({
        active: true
      });
    };

    _this.onBlur = function (e) {
      var handleBlur = _this.props.handleBlur;
      var _this$state = _this.state,
          addressObject = _this$state.addressObject,
          _this$state$selectedA = _this$state.selectedAddress,
          selectedAddress = _this$state$selectedA === void 0 ? '' : _this$state$selectedA;

      if (handleBlur) {
        handleBlur(e.target.value === '' ? '' : addressObject, selectedAddress);
      }

      _this.setState(function (prevState) {
        return {
          dirty: prevState.address !== '',
          active: false,
          error: prevState.address !== '' ? prevState.error : ''
        };
      });
    };

    _this.onSelect = function () {
      var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(address) {
        var coverage, results, latLng, okValues, isFormatedAddress, addressObject, isInCoverage, hasNumber;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                coverage = _this.props.coverage;
                _context.next = 3;
                return (0, _reactPlacesAutocomplete.geocodeByAddress)(address);

              case 3:
                results = _context.sent;
                _context.next = 6;
                return (0, _reactPlacesAutocomplete.getLatLng)(results[0]);

              case 6:
                latLng = _context.sent;
                okValues = ['premise', 'street_address'];

                if (results.length) {
                  _context.next = 10;
                  break;
                }

                throw new Error('No results to validate');

              case 10:
                isFormatedAddress = okValues.indexOf(results[0].types[0]) !== -1;
                addressObject = {
                  address: address,
                  lat: latLng.lat,
                  lng: latLng.lng
                };
                results[0].address_components.forEach(function (_ref2) {
                  var name = _ref2.long_name,
                      type = _ref2.types[0],
                      short_name = _ref2.short_name;

                  switch (type) {
                    case 'locality':
                      addressObject.locality = name;
                      break;

                    case 'postal_code':
                      addressObject.postalCode = name;
                      break;

                    case 'route':
                      addressObject.street = name;
                      break;

                    case 'street_number':
                      addressObject.number = name;
                      break;

                    case 'country':
                      addressObject.country = short_name;
                      break;

                    case 'administrative_area_level_2':
                      addressObject.province = short_name;
                      break;

                    default:
                  }
                });
                isInCoverage = coverage.length > 1 ? coverage.indexOf(addressObject.postalCode) !== -1 : true;
                hasNumber = typeof addressObject.number !== 'undefined';

                _this.setState({
                  address: isFormatedAddress && isInCoverage ? "".concat(addressObject.street, ", ").concat(addressObject.number, ", ").concat(addressObject.locality) : address,
                  selectedAddress: address,
                  error: !isFormatedAddress || !isInCoverage || !hasNumber,
                  errorReason: hasNumber && !isInCoverage ? 'addressNotInCoverage' : 'addressNotValidated',
                  errorText: undefined,
                  addressObject: {
                    street: "".concat(addressObject.street, ", ").concat(addressObject.number),
                    city: addressObject.locality,
                    postalCode: addressObject.postalCode,
                    country: addressObject.country,
                    province: addressObject.province,
                    location: {
                      lat: addressObject.lat,
                      lng: addressObject.lng
                    }
                  },
                  mapCenter: {
                    lat: addressObject.lat,
                    lng: addressObject.lng
                  }
                });

                _this.inputRef.current.blur();

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.onError = function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(status, clearSuggestions) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (status !== 'ZERO_RESULTS') {
                  console.warn('Google Maps API returned error with status: ', status);
                }

                clearSuggestions();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.getStatus = function () {
      var statuses = {
        active: _palette.palette.link,
        dirty: _palette.palette.bobBlack
      };
      var status = Object.keys(statuses).find(function (e) {
        return _this.state[e] === true;
      });
      return {
        status: status || 'default',
        color: statuses[status]
      };
    };

    _this.inputRef = props.innerRef || _react["default"].createRef();
    _this.state = {
      address: props.value || '',
      active: false,
      dirty: !!props.value || false,
      error: !!props.error,
      errorReason: '',
      errorText: props.error,
      location: props.location
    };
    return _this;
  }

  (0, _createClass2["default"])(Address, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;

      if (value && prevProps.value !== value) {
        this.setState({
          address: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          locale = _this$props.locale,
          width = _this$props.width,
          iconRight = _this$props.iconRight,
          required = _this$props.required;
      var _this$state2 = this.state,
          address = _this$state2.address,
          error = _this$state2.error,
          errorReason = _this$state2.errorReason,
          errorText = _this$state2.errorText,
          _this$state2$location = _this$state2.location,
          lat = _this$state2$location.lat,
          lng = _this$state2$location.lng;

      var _this$getStatus = this.getStatus(),
          status = _this$getStatus.status,
          color = _this$getStatus.color;

      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactPlacesAutocomplete["default"], {
        value: address,
        onChange: this.onChange,
        onSelect: this.onSelect,
        onError: this.onError,
        debounce: 500,
        highlightFirstSuggestion: true,
        shouldFetchSuggestions: address.length > 2,
        searchOptions: {
          location: new window.google.maps.LatLng(lat, lng),
          radius: 10000
        }
      }, function (_ref4) {
        var getInputProps = _ref4.getInputProps,
            suggestions = _ref4.suggestions,
            getSuggestionItemProps = _ref4.getSuggestionItemProps;
        return _react["default"].createElement(_style.AddressContainer, {
          width: width
        }, _react["default"].createElement(_style.AddressLabel, {
          iconRight: iconRight,
          status: status,
          error: error,
          color: color,
          htmlFor: id
        }, required && _react["default"].createElement(_styles.Asterisk, {
          error: error,
          status: status
        }), label), _react["default"].createElement(_style.AddressInput, (0, _extends2["default"])({
          status: status,
          error: error,
          color: color
        }, getInputProps(), {
          type: "text",
          id: id,
          value: address,
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          autoComplete: "off",
          ref: _this2.inputRef
        })), error && _react["default"].createElement(_style.AddressHelper, {
          error: true
        }, errorText || messages[errorReason][locale]), _react["default"].createElement(_style.AddressIcon, {
          iconRight: iconRight
        }, _react["default"].createElement(_Icon["default"], {
          icon: _icons.ICONS.PIN,
          size: 24,
          color: error ? _palette.palette.error : _this2.getStatus().color
        })), _react["default"].createElement(_style.AutocompleteContainer, null, suggestions.map(function (suggestion) {
          return _react["default"].createElement(_style.SuggestionItem, (0, _extends2["default"])({
            key: suggestion.id,
            "data-test-id": "addressSuggestion"
          }, getSuggestionItemProps(suggestion)), _react["default"].createElement("span", null, suggestion.description));
        })));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.error !== prevState.errorText) {
        return {
          error: !!nextProps.error,
          errorText: nextProps.error
        };
      }

      return null;
    }
  }]);
  return Address;
}(_react["default"].Component);

Address.propTypes = {
  location: _propTypes["default"].shape({}).isRequired,
  coverage: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  locale: _propTypes["default"].string,
  value: _propTypes["default"].string,
  error: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  handleChange: _propTypes["default"].func,
  handleBlur: _propTypes["default"].func,
  handleFocus: _propTypes["default"].func,
  iconRight: _propTypes["default"].bool,
  required: _propTypes["default"].bool
};
Address.defaultProps = {
  locale: 'en',
  value: '',
  error: undefined,
  width: undefined,
  handleChange: function handleChange() {},
  handleBlur: function handleBlur() {},
  handleFocus: function handleFocus() {},
  iconRight: false,
  required: false
};
var _default = Address;
exports["default"] = _default;